{
    "AS": "Asia",
    "EU": "Europe",
    "AF": "Africa",
    "NA": "North America",
    "SA": "South America",
    "AN": "Antarctica",
    "OC": "Oceania"
}